// Ограничения входа по коду. Отдельный файл без серверных модулей — его читает и форма в браузере.
export const CODE_LENGTH = 4 // макет: «Код — 4 цифры»
export const CODE_TTL_SEC = 5 * 60 // код действует 5 минут
export const RESEND_AFTER_SEC = 60 // «Отправить снова через …»
export const MAX_ATTEMPTS = 5 // столько раз можно ошибиться с одним кодом
export const MAX_CODES_PER_HOUR = 5 // столько кодов на один номер за час
